import React from 'react';
import PropTypes from 'prop-types';
import {
  DoughnutsWrapper,
  ClassroomIconWrapper,
  AttemptIconWrapper,
  PercentWrapper,
  LegendWrapper
} from './doughnut-chart.styled';
import { AttemptIcon } from '../../../../../helpers/icon-dictionary';
import SvgIcon from '../../../../svg-icon/svg-icon';
import DoughnutsClassroomIcon from './doughnut-classroom-icon/doughnut-classroom-icon';
import DoughnutsLegend from './doughnut-legend/doughnut-legend';
import DoughnutsInner from './doughnut-inner/doughnut-inner';

const Doughnuts = ({ i18n, displayChartData }) => {
  const {
    resultType,
    classroomPercent,
    groupPercent,
    studentPercent,
    studentName,
    truncatedName
  } = displayChartData;

  const percentages = [classroomPercent, groupPercent, studentPercent];
  return (
    <DoughnutsWrapper>
      <DoughnutsInner i18n={i18n} {...displayChartData} />
      <ClassroomIconWrapper type={resultType}>
        <DoughnutsClassroomIcon type={resultType} i18n={i18n} />
      </ClassroomIconWrapper>
      <PercentWrapper type={resultType} data-testid="student-percentage">
        {percentages[resultType] ? `${percentages[resultType]}%` : 'NA'}
      </PercentWrapper>
      <AttemptIconWrapper type={resultType}>
        <SvgIcon icon={AttemptIcon} />
      </AttemptIconWrapper>
      <LegendWrapper type={resultType}>
        <DoughnutsLegend
          i18n={i18n}
          type={resultType}
          studentName={studentName}
          truncatedName={truncatedName}
        />
      </LegendWrapper>
    </DoughnutsWrapper>
  );
};

Doughnuts.propTypes = {
  i18n: PropTypes.object,
  displayChartData: PropTypes.shape({
    resultType: PropTypes.number,
    studentName: PropTypes.string,
    truncatedName: PropTypes.string,
    studentPercent: PropTypes.number,
    completedActivitiesCount: PropTypes.number,
    totalActivitiesCount: PropTypes.number,
    groupPercent: PropTypes.number,
    groupActivitiesCount: PropTypes.number,
    classroomPercent: PropTypes.number,
    classActivitiesCount: PropTypes.number
  })
};

export default Doughnuts;



// WEBPACK FOOTER //
// ./components/student-list/student-modal/student-result/doughnut-chart/doughnut-chart.js